"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommsGate = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const component_1 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="wa-group-holder">
    ${(0, fast_element_1.when)(x => x.loaded && !x.logged, (0, fast_element_1.html) `
        <div class="gate-login">
            <div class="gate-login__card">
                <h2 class="gate-login__title">${() => 'whatsapp.groups.gate.title'.t()}</h2>
                <form class="gate-login__form" @submit="${(x, c) => x.submitLogin(c.event)}">
                    <div class="gate-login__field">
                        <label class="gate-login__label" for="gate-password">${() => 'whatsapp.groups.gate.password'.t()}</label>
                        <input
                            id="gate-password"
                            class="gate-login__input form-control"
                            type="password"
                            :value="${x => x.loginPassword}"
                            @input="${(x, c) => x.handlePasswordInput(c.event)}"
                            ?disabled="${x => x.loginLoading}"
                            autocomplete="current-password"
                        />
                    </div>
                    ${(0, fast_element_1.when)(x => !!x.loginError, (0, fast_element_1.html) `<div class="gate-login__error">${x => x.loginError}</div>`)}
                    <button class="gate-login__btn btn btn-primary w-100" type="submit" ?disabled="${x => x.loginLoading}">
                        ${(0, fast_element_1.when)(x => x.loginLoading, (0, fast_element_1.html) `<app-loader block="true" width="18" height="18"></app-loader>`)}
                        ${(0, fast_element_1.when)(x => !x.loginLoading, (0, fast_element_1.html) `${() => 'whatsapp.groups.gate.submit'.t()}`)}
                    </button>
                </form>
            </div>
        </div>
    `)}

    <main>
        <div class="container-fluid">
            <div class="dashboard-wrapper">
                ${(0, fast_element_1.when)(x => x.loaded && x.logged && !x.isDetailRoute, (0, fast_element_1.html) `
                    <settings-whatsapp
                        gated="true"
                        :commsType="${x => x.commsType}"
                        :phoneNumbersList="${x => x.phoneNumbersList}"
                    ></settings-whatsapp>
                `)}
                ${(0, fast_element_1.when)(x => x.loaded && x.logged && x.isDetailRoute, (0, fast_element_1.html) `
                    <rws-router
                        :currentUrl="${x => x.currentUrl}"
                        :injectProps="${x => ({ phoneNumbers: x.phoneNumbersList, commsType: x.commsType })}"
                        disableHistory="true"
                    />
                `)}
                ${(0, fast_element_1.when)(x => x.loaded, (0, fast_element_1.html) `<activity-panels></activity-panels>`)}
            </div>
        </div>
    </main>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.wa-group-holder {
  min-height: 100vh;
}

.gate-login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f4f6f8;
}
.gate-login__card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 380px;
}
.gate-login__title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #1a1a2e;
}
.gate-login__form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.gate-login__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.gate-login__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
}
.gate-login__input {
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
}
.gate-login__error {
  color: #dc3545;
  font-size: 0.875rem;
  text-align: center;
}
.gate-login__btn {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.5rem;
}`;
const shadowOptions = { "mode": "open" };
let CommsGate = class CommsGate extends client_1.RWSViewComponent {
    /**
     * Parsed list of allowed phone numbers from the `phoneNumbers` attribute.
     * Empty array means "no filter" — backwards compatible with the original
     * behaviour where the gate shows the group regardless of phone number.
     */
    get allowedPhoneNumbers() {
        if (!this.phoneNumbers)
            return [];
        return this.phoneNumbers
            .split(',')
            .map(p => p.trim())
            .filter(p => p.length > 0);
    }
    /**
     * True when the current URL points to a detail sub-route (DM contact,
     * group detail, or settings detail). When false, the gate renders
     * <whatsapp-settings-list> directly as the default page instead of
     * going through the router.
     *
     * Detail routes are anything beyond the bare list pages:
     *   /whatsapp/dm/...
     *   /whatsapp/group/...
     *   /settings/comms/<id>   (e.g. /settings/comms/1)
     */
    get isDetailRoute() {
        const url = this.currentUrl || '';
        if (!url)
            return false;
        if (url.startsWith('/comms/dm'))
            return true;
        if (url.startsWith('/comms/group'))
            return true;
        // /settings/comms/<id> — anything beyond the bare list page.
        // The bare list page is exactly '/settings/comms' (no trailing slash, no id).
        if (url.startsWith('/settings/comms')) {
            const rest = url.substring('/settings/comms'.length);
            // detail if there's a trailing slash or an id segment
            return rest.length > 0 && rest !== '/';
        }
        return false;
    }
    constructor(storageService, wsService) {
        super();
        this.storageService = storageService;
        this.wsService = wsService;
        this.groupId = null;
        this.phoneNumbers = '';
        this.apiKey = null;
        this.loaded = false;
        this.logged = false;
        this.loginPassword = '';
        this.loginError = '';
        this.loginLoading = false;
        this.phoneNumbersList = [];
        this.currentUrl = null;
        this._routingUrlChangedHandler = null;
    }
    changeRoute(path) {
        console.log('CommsGate changeRoute', { path });
        this.currentUrl = path;
    }
    applyToken(token) {
        this.apiService.setToken(token);
        this.wsService.setToken(token);
        this.wsService.init();
    }
    async connectedCallback() {
        super.connectedCallback();
        window.dispatchEvent(new CustomEvent('comms-gate:ready', { detail: { component: this } }));
        this.getBody().classList.add('loaded');
        this.togglePreloader();
        if (this.apiKey) {
            const { token, user } = (await this.apiService.back.post('auth.api-authorize', { apikey: this.apiKey })).data;
            component_1.DefaultLayout.USER = user;
            this.applyToken(token);
            this.logged = true;
        }
        else {
            const jwtToken = this.storageService.get('jwt_gate_token');
            const user = (await this.apiService.back.post('user.logged', { apikey: this.apiKey })).data;
            if (jwtToken) {
                this.applyToken(jwtToken);
                component_1.DefaultLayout.USER = user;
                this.logged = true;
            }
        }
        if (this.phoneNumbers && this.phoneNumbers.length > 0) {
            this.phoneNumbersList = this.phoneNumbers
                .split(',')
                .map(p => {
                p = p.trim();
                if (!p.includes('+')) {
                    p = `+${p}`;
                }
                return p;
            })
                .filter(p => p.length > 0);
        }
        // Listen for routing.url.changed events dispatched on window by SiteMenu.goto().
        // The event is dispatched on window so it crosses the shadow DOM boundary.
        this._routingUrlChangedHandler = (event) => {
            const detail = event.detail;
            this.currentUrl = (detail === null || detail === void 0 ? void 0 : detail.item) || null;
        };
        window.addEventListener('routing.url.changed', this._routingUrlChangedHandler);
        console.log('CommsGate initialized', {
            groupId: this.groupId,
            phoneNumbers: this.phoneNumbers,
            apiKey: this.apiKey,
            logged: this.logged,
            currentUrl: this.currentUrl,
            allowedPhoneNumbers: this.allowedPhoneNumbers
        });
        this.loaded = true;
    }
    async submitLogin(event) {
        event.preventDefault();
        if (!this.loginPassword || this.loginLoading) {
            return;
        }
        this.loginLoading = true;
        this.loginError = '';
        try {
            const response = await this.apiService.back.post('whatsapp.groups.public_auth', { id: String(this.groupId), password: this.loginPassword });
            if ((response === null || response === void 0 ? void 0 : response.auth) && response.token) {
                this.storageService.set('jwt_gate_token', response.token);
                this.applyToken(response.token);
                this.logged = true;
            }
            else {
                this.loginError = 'whatsapp.groups.gate.error'.t();
            }
        }
        catch (e) {
            console.error(e);
            this.loginError = 'whatsapp.groups.gate.error'.t();
        }
        finally {
            this.loginLoading = false;
        }
    }
    handlePasswordInput(event) {
        this.loginPassword = event.target.value;
    }
    disconnectedCallback() {
        // Clean up the window-level routing listener to avoid memory leaks.
        if (this._routingUrlChangedHandler) {
            window.removeEventListener('routing.url.changed', this._routingUrlChangedHandler);
            this._routingUrlChangedHandler = null;
        }
        super.disconnectedCallback();
    }
    getBody() {
        return document.querySelector('body');
    }
    getPreloader() {
        return document.querySelector('#preloader');
    }
    togglePreloader() {
        const preloader = this.getPreloader();
        if (preloader) {
            if (preloader.classList.contains('hidden')) {
                preloader.classList.remove('hidden');
            }
            else {
                preloader.classList.add('hidden');
            }
        }
    }
};
exports.CommsGate = CommsGate;
__decorate([
    client_1.attr,
    __metadata("design:type", Number)
], CommsGate.prototype, "groupId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsGate.prototype, "phoneNumbers", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsGate.prototype, "commsType", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], CommsGate.prototype, "apiKey", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsGate.prototype, "loaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsGate.prototype, "logged", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsGate.prototype, "loginPassword", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsGate.prototype, "loginError", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CommsGate.prototype, "loginLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CommsGate.prototype, "phoneNumbersList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CommsGate.prototype, "currentUrl", void 0);
exports.CommsGate = CommsGate = __decorate([
    (0, client_1.RWSView)('comms-gate', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __param(1, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object, typeof (_b = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _b : Object])
], CommsGate);
CommsGate.defineComponent();
